import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {/*  Building2  */} from "lucide-react";
import { supabase } from "../lib/supabase";
import "./HrLoginPage.css";

export default function HrLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      alert(error.message);
      setLoading(false);
      return;
    }

    navigate("/hr-dashboard");
  };

  return (
    <div className="hr-root">
      <div className="hr-card">
        <div className="hr-header">
          <img src="/logo1.png" alt="Migarda" className="hr-logo" />
        </div>
        <p className="hr-subtitle">Sign in to access the dashboard</p>

        <form onSubmit={handleLogin} className="hr-form">
          <div className="hr-field">
            <label className="hr-label">Email</label>
            <input
              className="hr-input"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="hr-field">
            <label className="hr-label">Password</label>
            <input
              className="hr-input"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button className="hr-button" type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}